<template>
  <div>
    <transition-group name="slide-fade">
      <div
        v-for="alert in list"
        :key="alert.id"
      >
        <FixAlert
          :id="alert.id"
          :message="alert.message"
          :color="alert.color"
          :icon="alert.icon"
          :text="alert.text"
          :retryable="alert.retryable"
          :height="alert.height"
          :width="alert.width"
          :action="alert.action"
          :type="alert.type"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>
import FixAlert from './MyAlert.vue'

export default {
  name: 'AlertList',
  components: {
    FixAlert
  },
  computed: {
    list () {
      return this.$store.state.alertModule.alertList
    }
  }
}
</script>

<style scoped>

.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

</style>
